import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import LogoIcon from '@/components/shared/icons/LogoIcon';
// import en from 'vuetify/src/locale/en';
import en from 'vuetify/es5/locale/en';
import MarketIcon from '@/components/shared/icons/MarketIcon';
import AddResourcesIcon from '@/components/shared/icons/AddResourcesIcon';
import ControlValuesIcon from '@/components/shared/icons/ControlValuesIcon';
import HelpIcon from '@/components/shared/icons/HelpIcon';
import MyCollectionIcon from '@/components/shared/icons/MyCollectionIcon';
import PendingRegistrationIcon from '@/components/shared/icons/PendingRegistrationIcon';
import ProvidersIcon from '@/components/shared/icons/ProvidersIcon';
import UsersIcon from '@/components/shared/icons/UsersIcon';
import YourResourcesIcon from '@/components/shared/icons/YourResourcesIcon';
import DashboardIcon from '@/components/shared/icons/DashboardIcon';
import BellIcon from '@/components/shared/icons/BellIcon';
import CameraIcon from '@/components/shared/icons/CameraIcon';
import SignOutIcon from '@/components/shared/icons/SignOutIcon';
import BackIcon from '@/components/shared/icons/BackIcon';
import NextIcon from '@/components/shared/icons/NextIcon';
import TrashIcon from '@/components/shared/icons/TrashIcon';
import PlusIcon from '@/components/shared/icons/PlusIcon';
import PurplePlusIcon from '@/components/shared/icons/PurplePlusIcon';
import PurpleNextIcon from '@/components/shared/icons/PurpleNextIcon';
import FavoriteIcon from '@/components/shared/icons/FavoriteIcon';
import FilterIcon from '@/components/shared/icons/FilterIcon';
import LinkedinIcon from '@/components/shared/icons/Linkedin';
import Facebook from '@/components/shared/icons/Facebook';
import Twitter from '@/components/shared/icons/Twitter';
import Instagram from '@/components/shared/icons/Instagram';
import SocialMedia from '@/components/shared/icons/SocialMedia';
import Youtube from '@/components/shared/icons/Youtube';
import OrderSettings from '@/components/shared/icons/OrderSettings';
import AddProviderIcon from '@/components/shared/icons/AddProviderIcon';
import EyeIcon from '@/components/shared/icons/EyeIcon';
import StatisticsIcon from '@/components/shared/icons/StatisticsIcon';
import SuggestedIcon from '@/components/shared/icons/SuggestedIcon.vue';
import DuplicateIcon from '@/components/shared/icons/DuplicateIcon.vue';
import EmailIcon from '@/components/shared/icons/EmailIcon.vue';
import SearchIcon from '@/components/shared/icons/SearchIcon.vue';
import OrderIcon from '@/components/shared/icons/OrderIcon.vue';
import CollaborateIcon from '@/components/shared/icons/CollaborateIcon.vue';
import NewsIcon from '@/components/shared/icons/NewsIcon.vue';
import HostingInstitutionIcon from '@/components/shared/icons/HostingInstitutionIcon.vue';
import EquipmentIcon from '@/components/shared/icons/EquipmentIcon.vue';
import IntellectualPropertyIcon from '@/components/shared/icons/IntellectualPropertyIcon.vue';
import UserManagementIcon from '@/components/shared/icons/UserManagementIcon.vue';
import ResourcesIcon from '@/components/shared/icons/ResourcesIcon.vue';
import CampaignIcon from '@/components/shared/icons/CampaignIcon.vue';
import ErrorCircleIcon from '@/components/shared/icons/ErrorCircleIcon.vue';
import DeleteCircleIcon from '@/components/shared/icons/DeleteCircleIcon.vue';
import PatentIcon from '@/components/shared/icons/PatentIcon.vue';
import NewsAndEventsIcon from '@/components/shared/icons/NewsAndEventsIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#230059',
        primary400: '#3C0099',
        primary300: '#6400FF',
        primary200: '#A870FF',
        primary100: '#D4B8FF',
        primary50: '#EDE0FF',
        secondary: '#091D55',
        secondary400: '#143EB7',
        secondary300: '#1B53F4',
        secondary200: '#85A4FA',
        secondary100: '#CFDAFC',
        secondary50: '#E8EEFE',
        success: '#22C55E',
        warning: '#F59E0B',
        error: '#EF4444',
        danger: '#EF4444',
        neutral: '#1E232C',
        neutral700: '#555557',
        neutral600: '#6E6D70',
        neutral500: '#929195',
        neutral400: '#C3C2C7',
        neutral300: '#DCDAE0',
        neutral200: '#F4F2F9',
        neutral100: '#FAFAFA',
        neutral50: '#FFFFFF',
        body: '#4B5666',
        label: '#6E7C91',
        placeholder: '#838286',
        line: '#D9E3E9',
        inputBackground: '#EFF4F6',
        primaryBackground: '#FFFFFF',
        secondaryBackground: '#FCFCFC',
        offWhite: '#F7FBFC',
        fullWhite: '#FFFFFF',
        shadow: '#F4F2F9',
        deactivated: '#424242',
        hover: '#1B4EED',
      },
    },
  },
  icons: {
    values: {
      logo: {
        // name of our custom icon
        component: LogoIcon, // our custom component
      },
      dashboard: {
        component: DashboardIcon,
      },
      marketplace: {
        component: MarketIcon,
      },
      addResources: {
        component: AddResourcesIcon,
      },
      controlValues: {
        component: ControlValuesIcon,
      },
      help: {
        component: HelpIcon,
      },
      myCollection: {
        component: MyCollectionIcon,
      },
      orderSettings: {
        component: OrderSettings,
      },
      pendingRegistration: {
        component: PendingRegistrationIcon,
      },
      providers: {
        component: ProvidersIcon,
      },
      users: {
        component: UsersIcon,
      },
      email: {
        component: EmailIcon,
      },
      yourResources: {
        component: YourResourcesIcon,
      },
      bell: {
        component: BellIcon,
      },
      camera: {
        component: CameraIcon,
      },
      signOut: {
        component: SignOutIcon,
      },
      back: {
        component: BackIcon,
      },
      prev: {
        component: BackIcon,
      },
      next: {
        component: NextIcon,
      },
      trash: {
        component: TrashIcon,
      },
      plus: {
        component: PlusIcon,
      },
      purplePlus: {
        component: PurplePlusIcon,
      },
      search: {
        component: SearchIcon,
      },
      order: {
        component: OrderIcon,
      },
      collaborate: {
        component: CollaborateIcon,
      },
      news: {
        component: NewsIcon,
      },
      institution: {
        component: HostingInstitutionIcon,
      },
      equipment: {
        component: EquipmentIcon,
      },
      intellectualProperty: {
        component: IntellectualPropertyIcon,
      },
      userManagement: {
        component: UserManagementIcon,
      },
      resources: {
        component: ResourcesIcon,
      },
      purpleNext: {
        component: PurpleNextIcon,
      },
      favorite: {
        component: FavoriteIcon,
      },
      filter: {
        component: FilterIcon,
      },
      linkedin: {
        component: LinkedinIcon,
      },
      facebook: {
        component: Facebook,
      },
      twitter: {
        component: Twitter,
      },
      instagram: {
        component: Instagram,
      },
      socialMedia: {
        component: SocialMedia,
      },
      youtube: {
        component: Youtube,
      },
      addProvider: {
        component: AddProviderIcon,
      },
      eye: {
        component: EyeIcon,
      },
      statistics: {
        component: StatisticsIcon,
      },
      suggested: {
        component: SuggestedIcon,
      },
      duplicate: {
        component: DuplicateIcon,
      },
      campaign: {
        component: CampaignIcon,
      },
      newsAndEvents: {
        component: NewsAndEventsIcon,
      },
      errorCirle: {
        component: ErrorCircleIcon,
      },
      deleteCircle: {
        component: DeleteCircleIcon,
      },
      patent: {
        component: PatentIcon,
      },
    },
  },
  lang: {
    locales: { en },
    current: 'en',
  },
});
